<template>
    <v-modal ref="modal" @opened="modalOpened" >
        <slot slot="title">{{ $t('users.add_new_user') }}</slot>
        <slot slot="buttonContent">
            <v-block type="mini" height="stretch" color="white">
                <span class="u-flex-set"><button class="c-button c-button--icon-only" type="button"><svgicon name="added"></svgicon></button></span>
            </v-block>
        </slot>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-input v-model="User.Email" name="user_email" :fluid="true" :error="Validate.Email">
                            <slot slot="label">{{ $t('users.email') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row v-if="roleOptions && roleOptions.length">
                        <v-custom-select v-model="selectedRole"
                                         :options="roleOptions"
                                         option-name="content" option-value="value" name="role" search-label="content" track-by="value"
                                         :fluid="true" :multiple="false"
                                         @input="setRole">
                            <slot slot="label">{{ $t('users.role') }}</slot>
                        </v-custom-select>
                    </v-form-row>
                    <v-form-row v-if="isSalesMan">
                        <v-input v-model="User.SalesTakerCode" name="user_sales_taker_code" :fluid="true">
                            <slot slot="label">{{ $t('users.sales_taker_code') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click.prevent="addNewUser" class="c-button c-button--alpha">{{ $t('users.submit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>       
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VFormRow from '@/components/form/Row'
    import VInput from '@/components/form/Input'
    import VLabel from '@/components/form/Label'
    import VCustomSelect from '@/components/form/CustomSelect'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VFormRow,
            VInput,
            VLabel,
            VCustomSelect
        },
        data() {
            return {
                User: {
                    Id: "00000000-0000-0000-0000-000000000000",
                    Email: "",
                    Role: "",
                    SalesTakerCode: null,
                    CustomerId: this.customerKey
                },
                Validate: {}
            }
        },
        props: {
            customerKey: Number,
            roleOptions: Array
        },
        watch: {
            customerKey() {
                this.User.CustomerId = this.customerKey;
            }
        },
        computed: {
            selectedRole: {
                get () {
                    let output;
                    output = this.roleOptions.find((obj) => {
                        return obj.value === this.User.Role;
                    });

                    if (output) {
                        this.$set(this.User, 'Role', output.value);
                    }

                    return output ? output : {};
                },
                set (value) {
                    this.$set(this.User, 'Role', value.value);
                    return value;
                }
            },
            isSalesMan(){
                return this.User.Role === 'Vertegenwoordiger';
            }
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;
                console.log(errors);
                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('addUserModel.', '');
                    errors[key] = errors['addUserModel.'+key][0];
                    delete errors['addUserModel.'+key];
                });                
                this.Validate = errors;
                console.log(this.Validate);
            },
            addNewUser() {
                this.$store.dispatch('addCustomerUser', {
                    id: this.customerKey,
                    body: this.User
                }).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.User.Id = response;
                        this.$emit('userAdded', this.User);
                        this.$refs.modal.closeDialog();                
                    }                    
                 });         
            },
            setRole(value) {
                this.User.Role = value.value;
            },
            modalOpened(){
                this.User = {
                    Id: "00000000-0000-0000-0000-000000000000",
                    Email: "",
                    Role: "",
                    SalesTakerCode: null,
                    CustomerId: this.customerKey
                };
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/form/userSelect/AddUser.vue